import React from 'react';

function VideoInfo({ title, status, description }) {
  const containerStyle = {
    backgroundColor: '#1a1a1a',
    borderRadius: '12px',
    padding: '20px',
    marginTop: '15px',
    border: '1px solid #333'
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px'
  };

  const logoStyle = {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #D7B615 0%, #B8981A 100%)',
    marginRight: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '1.2em',
    color: '#000',
    boxShadow: '0 2px 8px rgba(215, 182, 21, 0.3)'
  };

  const infoStyle = {
    flex: 1
  };

  const titleStyle = {
    fontWeight: 'bold',
    fontSize: '1.2em',
    color: 'white',
    marginBottom: '4px',
    lineHeight: '1.3'
  };

  const channelStyle = {
    fontSize: '0.9em',
    color: 'rgba(255, 255, 255, 0.6)',
    marginBottom: '8px'
  };

  const statusStyle = {
    fontSize: '0.85em',
    color: '#ff4444',
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 68, 68, 0.1)',
    padding: '4px 12px',
    borderRadius: '20px',
    border: '1px solid rgba(255, 68, 68, 0.3)'
  };

  const liveDotStyle = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#ff4444',
    marginRight: '6px',
    animation: 'pulse 2s infinite'
  };

  const descriptionStyle = {
    fontSize: '0.9em',
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: '1.5',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid #333'
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <div style={logoStyle}>ML</div>
        <div style={infoStyle}>
          <div style={titleStyle}>{title}</div>
          <div style={channelStyle}>Mi Legado - Trading Academy</div>
          {status === 'LIVE' && (
            <span style={statusStyle}>
              <span style={liveDotStyle}></span>
              EN VIVO
            </span>
          )}
        </div>
      </div>
      {description && (
        <div style={descriptionStyle}>{description}</div>
      )}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
}

export default VideoInfo; 